import { ResolutionTime } from '../telematics/components/Colorizer/ResolutionTime';
import ErrorColor from '../../shared/ErrorColor.svelte';
import SuccessColor from '../../shared/SuccessColor.svelte';
import WarningColor from '../../shared/WarningColor.svelte';
import Dummy from '../../shared/Dummy.svelte';

export type TimeWindowType = {
    from: string | null | undefined;
    to: string | null | undefined;
    eta: string | null;
    fulfilled: boolean | null;
    delivered: boolean | null | undefined;
};

export class TimeWindow {
    private timeWindow: TimeWindowType;
    private minutesStart: number | null;
    private minutesEnd: number | null;
    private minutesTarget: number | null;
    private errorThreshold: number = 15;

    constructor(timeWindow: TimeWindowType) {
        this.timeWindow = timeWindow;
        this.minutesStart = timeWindow?.from
            ? ResolutionTime.getMinutesFromHourString(timeWindow.from)
            : null;
        this.minutesEnd = timeWindow?.to
            ? ResolutionTime.getMinutesFromHourString(timeWindow.to)
            : null;
        if (
            this.minutesStart !== null &&
            this.minutesEnd !== null &&
            this.minutesStart > this.minutesEnd
        ) {
            this.minutesEnd += 24 * 60;
        }
        this.minutesTarget =
            timeWindow.eta !== null
                ? ResolutionTime.getMinutesFromHourString(timeWindow.eta)
                : null;
    }

    public isValid(): boolean {
        return this.minutesStart !== null || this.minutesEnd !== null;
    }

    public isEtaExists(): boolean {
        return this.minutesTarget !== null;
    }

    public isFulfilled(): boolean {
        // return (
        //     this.isValid() &&
        //     (this.minutesStart === null || this.minutesStart <= this.minutesTarget) &&
        //     (this.minutesEnd === null || this.minutesEnd % (24 * 60) >= this.minutesTarget)
        // );
        return this.isFulfilledFrom() && this.isFulfilledTo();
    }

    public isFulfilledFrom(): boolean {
        // if (this.minutesTarget === null) {
        //     return true;
        // }
        return (
            this.isValid() &&
            this.minutesTarget !== null &&
            (this.minutesStart === null || this.minutesStart <= this.minutesTarget)
        );
    }

    public isFulfilledTo(): boolean {
        // if (this.minutesTarget === null) {
        //     return true;
        // }
        return (
            this.isValid() &&
            this.minutesTarget !== null &&
            (this.minutesEnd === null || this.minutesEnd % (24 * 60) >= this.minutesTarget)
        );
    }

    public isAboveThreshold(): boolean {
        if (this.isValid() && !this.isFulfilled()) {
            return this.getDifference(true) > this.errorThreshold;
        } else {
            return false;
        }
    }

    public getDifference(abs: boolean = false): number {
        let diff: number = 0;
        if ((this.isValid() || !this.isFulfilled) && this.minutesTarget !== null) {
            if (this.minutesStart !== null && this.minutesTarget < this.minutesStart) {
                diff = this.minutesTarget - this.minutesStart;
            } else if (this.minutesEnd) {
                diff = this.minutesTarget - this.minutesEnd;
            }
        }
        return abs ? Math.abs(diff) : diff;
    }

    public getTimeWindow(): TimeWindowType {
        return this.timeWindow;
    }

    public getErrorThreshold(): number {
        return this.errorThreshold;
    }

    public getColorComponentGlobal(): any {
        if (!this.isEtaExists()) {
            return Dummy; // Success
        }
        if (this.isFulfilled()) {
            return Dummy; // SuccessColor;
        } else {
            return ErrorColor;
        }
        // if (this.isAboveThreshold()) {
        //     return ErrorColor;
        // } else if (this.isFulfilled()) {
        //     return Dummy; // SuccessColor;
        // } else {
        //     return WarningColor;
        // }
    }

    public getColorComponentFrom(): any {
        if (!this.isEtaExists()) {
            return Dummy; // Success
        }
        if (this.isFulfilledFrom()) {
            return Dummy; // SuccessColor;
        } else {
            return ErrorColor;
        }
    }

    public getColorComponentTo(): any {
        if (!this.isEtaExists()) {
            return Dummy; // Success
        }
        if (this.isFulfilledTo()) {
            return Dummy; // SuccessColor;
        } else {
            return ErrorColor;
        }
    }
    
    public getColorComponent(): any {
        if (!this.isEtaExists()) {
            return Dummy; // Success
        }
        if (this.isFulfilled()) {
            return Dummy; // SuccessColor;
        } else {
            return ErrorColor;
        }
    }
}
